exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list[data-v-deab1ab2]{position:relative}.list .wrapper[data-v-deab1ab2]{overflow:hidden;position:absolute;top:.5rem;left:0;right:0;bottom:0}.sticky-top-cust[data-v-deab1ab2]{position:-webkit-sticky;position:sticky;top:0;z-index:1000}", ""]);

// exports
